import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-users-edit-modal',
  templateUrl: './users-edit-modal.component.html',
  styleUrls: ['./users-edit-modal.component.css']
})
export class UsersEditModalComponent implements OnInit {

  @Input() user: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSaveUser = new EventEmitter<any>();


  ngOnInit() {

  }

  onUpdateUser(evt: any) {
    this.onSaveUser.emit(evt);
  }

    closeModal() {
    this.onCloseModal.emit();
  }

}
